import {
  IVitalListEmptyEntry,
  IVitalListEntry,
  TRecordConfig,
  TVitalDataResponse,
  TVitalDataSearchItem,
  TVitalSettingsResponse,
} from '../../../types/life-id';
import getGraphData from '../get-graph-data';
import { getDetailRowProps } from '../get-detail-row-props';
import getBadgeProps from '../get-badge-props';

/**
 *
 * @param vitalData
 * @param vitalDataSettings
 * @param config TRecordConfig
 */
export default function healthRateEntry(
  vitalData: TVitalDataResponse | null,
  vitalDataSettings: TVitalSettingsResponse | null,
  config: TRecordConfig,
): IVitalListEntry | IVitalListEmptyEntry {
  const emptyEntry: IVitalListEmptyEntry = {
    isEmpty: true,
    iconSrc: require('../../../assets/svg/icon-heart.svg').default,
    title: 'life_id.heartRate',
  };

  if (!vitalDataSettings || !vitalData || !vitalData.heartRate) {
    return emptyEntry;
  }

  const settings = [vitalDataSettings.heartRate];
  const lastRecord = vitalData.heartRate.lastRecord;

  return {
    ...emptyEntry,
    modalType: 'HR' as const,
    isEmpty: false,
    average: vitalData.heartRate.average || '-',
    status: `life_id:status.${lastRecord.status}`,
    ...getBadgeProps(lastRecord.source),
    getDetailRowProps: getDetailRowProps(
      settings,
      config.HR.valueSelectors[0] as keyof TVitalDataSearchItem,
    ),
    summaryChartProps: {
      oneSidedRange: false,
      unit: `units.${config.HR.unit}`,
      value: lastRecord.bpm || '-',
      ...getGraphData(settings, [lastRecord.bpm]),
    },
    urlPart: config.HR.urlPart,
  };
}
